import { useLocalization } from "../../features/localization/index.js";
import { computed, defineComponent, h, ref, render } from "vue";
import { useTooltip } from "@scalar/components/tooltip";
//#region src/v2/components/code-input/PillTooltipHost.vue?vue&type=script&setup=true&lang.ts
var PillTooltipHost_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	name: "PillTooltipHost",
	__name: "PillTooltipHost",
	props: {
		context: {},
		target: {},
		translate: { type: Function }
	},
	setup(__props) {
		/**
		* PillTooltipHost
		*
		* Renderless adapter that attaches a tooltip to an existing DOM element.
		* Both the legacy CodeMirror widget pipeline and the new `CodeInputLite`
		* overlay mount one of these per pill via `createApp` — they keep ownership
		* of the pill DOM (text, classes, styles) and we only attach hover/focus
		* behaviour through `useTooltip`.
		*
		* The component renders nothing of its own; pass the pill element via the
		* `target` prop and `useTooltip` will wire mouseenter/mouseleave/focus/blur
		* listeners onto it directly.
		*/
		const props = __props;
		const { translate: fallbackTranslate } = useLocalization();
		const translate = props.translate ?? fallbackTranslate;
		const isContextFn = props.context.type === "contextFunction";
		/** Two-line HTML body for context-function tooltips. */
		const contextTooltipHtml = computed(() => {
			if (!isContextFn || typeof document === "undefined" || props.context.type !== "contextFunction") return "";
			const el = document.createElement("div");
			render(h("div", { class: "flex flex-col gap-1.5 text-left" }, [h("span", {}, props.context.details), h("div", { class: "text-[color:var(--scalar-color-3)] text-[10px] font-normal" }, translate("apiClient.pillTooltipHost.computedAtExecution"))]), el);
			return el.innerHTML;
		});
		const environmentTooltipText = computed(() => {
			if (props.context.type !== "environment") return "";
			return props.context.isDefined ? props.context.value : translate("apiClient.pillTooltipHost.noValue");
		});
		const targetRef = ref(props.target);
		useTooltip({
			content: isContextFn ? contextTooltipHtml : environmentTooltipText,
			contentTarget: isContextFn ? "innerHTML" : "textContent",
			delay: 0,
			placement: "bottom-start",
			offset: 6,
			targetRef
		});
		return (_ctx, _cache) => {
			return null;
		};
	}
});
//#endregion
export { PillTooltipHost_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=PillTooltipHost.vue_vue_type_script_setup_true_lang.js.map